// Small 2D helpers for grid-space effects (extend for skew, rotation fields, etc.).

export const vec2 = (x, y) => ({ x, y });

export const sub = (a, b) => vec2(a.x - b.x, a.y - b.y);

export const len = (v) => Math.hypot(v.x, v.y);

export const dist = (a, b) => len(sub(a, b));

// [a,b,c,d] · (x,y) — row-major 2×2
export const mulMat2 = (m, v) => vec2(
    m[0] * v.x + m[1] * v.y,
    m[2] * v.x + m[3] * v.y,
);

// 0 when x <= edge0, 1 when x >= edge1
export const smoothstep = (edge0, edge1, x) => {
    if (edge0 === edge1) return x >= edge1 ? 1 : 0;
    const t = Math.max(0, Math.min(1, (x - edge0) / (edge1 - edge0)));
    return t * t * (3 - 2 * t);
};

export const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
